import BaseService from './BaseService'
import UserModel from '../models/UserModel'
import VerModel from '../models/VerModel'
import AdminModel from '../models/AdminModel'
import AccountModel from '../models/AccountModel'
import NotificationsModel from '../models/NotificationsModel'
import StatusModel from '../models/StatusModel'
import StateModel from '../models/StateModel'
import DistrictModel from '../models/DistrictModel'
import WardModel from '../models/WardModel'
import StatusDocumentModel from '../models/StatusDocumentModel'
import StatusTDModel from '../models/StatusTDModel'
import OfficeVPLKModel from '../models/OfficeVPLKModel'
import OfficeVPLKTplModel from '../models/OfficeVPLKTplModel'
import OfficeTPLModel from '../models/OfficeTPLModel'
import OfficeAgencyModel from '../models/OfficeAgencyModel'
import OfficeAgencyTplModel from '../models/OfficeAgencyTplModel'
import HistoryNiemYetModel from '../models/HistoryNiemYetModel'
import GroupPermissionModel from '../models/GroupPermissionModel'
import ImportDocumentModel from '../models/ImportDocumentModel'
import ListDocumentModel from '../models/ListDocumentModel'
import StatementDetailModel from '../models/StatementDetailModel'
import StatementReturnCourtModel from '../models/StatementReturnCourtModel'
import ComputeSalaryModel from '../models/ComputeSalaryModel'
import ComputeSalaryOutboundModel from '../models/ComputeSalaryOutboundModel'
import PayrollEmployeeModel from '../models/PayrollEmployeeModel'
import ReportCompleteLateModel from '../models/ReportCompleteLateModel'
import ReportUnCompleteLateModel from '../models/ReportUnCompleteLateModel'
import ReportComparisonModel from '../models/ReportComparisonModel'
import HolidaySettingModel from '../models/HolidaySettingModel'
import UserDpvModel from '../models/UserDpvModel'
import AreaModel from '../models/AreaModel'
import UserTdvModel from '../models/UserTdvModel'
import SalaryPricelistModel from '../models/SalaryPricelistModel'
import SalaryPricelistProvinceModel from '../models/SalaryPricelistProvinceModel'
import OrganPricelistProvinceModel from '../models/OrganPricelistProvinceModel'
import OrganPricelistModel from '../models/OrganPricelistModel'
import DocumentTmpModel from '../models/DocumentTmpModel'
import CourtAccountModel from '../models/CourtAccountModel'
import HistoryFormal from '../models/HistoryFormal'
import ReportComparisonAgencyModel from '../models/ReportComparisonAgencyModel'
import ReportDocsTdvModel from '../models/ReportDocsTdvModel'
import ReportGeneralEmployeeInventoryModel from '../models/ReportGeneralEmployeeInventoryModel'
export default {
    services: {
      'report_general_employee_inventory': {
        'model': new ReportGeneralEmployeeInventoryModel(),
        'service': new BaseService(new ReportGeneralEmployeeInventoryModel())
      },
      'report_docs_tdv': {
        'model': new ReportDocsTdvModel(),
        'service': new BaseService(new ReportDocsTdvModel())
      },
      'report_comparison_agency': {
        'model': new ReportComparisonAgencyModel(),
        'service': new BaseService(new ReportComparisonAgencyModel())
      },
      'history_formal_td': {
        'model': new HistoryFormal(),
        'service': new BaseService(new HistoryFormal())
      },
      'accounts': {
        'model': new AccountModel(),
        'service': new BaseService(new AccountModel())
      },
      'admin': {
        'model': new AdminModel(),
        'service': new BaseService(new AdminModel())
      },
      'users': {
        'model': new UserModel(),
        'service': new BaseService(new UserModel())
      },
      'ver': {
        'model': new VerModel(),
        'service': new BaseService(new VerModel())
      },
      'state': {
        'model': new StateModel(),
        'service': new BaseService(new StateModel())
      },
      'district': {
        'model': new DistrictModel(),
        'service': new BaseService(new DistrictModel())
      },
      'ward': {
        'model': new WardModel(),
        'service': new BaseService(new WardModel())
      },
      'status_document': {
        'model': new StatusDocumentModel(),
        'service': new BaseService(new StatusDocumentModel())
      },
      'status_tongdat': {
        'model': new StatusTDModel(),
        'service': new BaseService(new StatusTDModel())
      },
      'office_vplk': {
        'model': new OfficeVPLKModel(),
        'service': new BaseService(new OfficeVPLKModel())
      },
      'office_vplk_tpl': {
        'model': new OfficeVPLKTplModel(),
        'service': new BaseService(new OfficeVPLKTplModel())
      },
      'office_tpl': {
        'model': new OfficeTPLModel(),
        'service': new BaseService(new OfficeTPLModel())
      },
      'office_agency': {
        'model': new OfficeAgencyModel(),
        'service': new BaseService(new OfficeAgencyModel())
      },
      'office_agency_tpl': {
        'model': new OfficeAgencyTplModel(),
        'service': new BaseService(new OfficeAgencyTplModel())
      },
      'history_niemyet': {
        'model': new HistoryNiemYetModel(),
        'service': new BaseService(new HistoryNiemYetModel())
      },
      'notification': {
          'service': new BaseService(new NotificationsModel()),
          'model': new NotificationsModel(),
          'rels': [],
      },
      'status': {
        'service': new BaseService(new StatusModel()),
        'model': new StatusModel(),
        'rels': []
      },
      'group_permission': {
        'service': new BaseService(new GroupPermissionModel()),
        'model': new GroupPermissionModel(),
        'rels': []
      },
      'document': {
        'model': new ImportDocumentModel(),
        'service': new BaseService(new ImportDocumentModel())
      },
      'document_temp': {
        'model': new DocumentTmpModel(),
        'service': new BaseService(new DocumentTmpModel())
      },
      'list_document': {
        'model': new ListDocumentModel(),
        'service': new BaseService(new ListDocumentModel())
      },
      'statement_detail': {
        'model': new StatementDetailModel(),
        'service': new BaseService(new StatementDetailModel())
      },
      'statement_return_court': {
        'model': new StatementReturnCourtModel(),
        'service': new BaseService(new StatementReturnCourtModel())
      },
      'compute_salary': {
        'model': new ComputeSalaryModel(),
        'service': new BaseService(new ComputeSalaryModel())
      },
      'compute_salary_outbound': {
        'model': new ComputeSalaryOutboundModel(),
        'service': new BaseService(new ComputeSalaryOutboundModel())
      },
      'payroll_employee': {
        'model': new PayrollEmployeeModel(),
        'service': new BaseService(new PayrollEmployeeModel())
      },
      'report_complete_late': {
        'model': new ReportCompleteLateModel(),
        'service': new BaseService(new ReportCompleteLateModel())
      },
      'report_uncomplete_late': {
        'model': new ReportUnCompleteLateModel(),
        'service': new BaseService(new ReportUnCompleteLateModel())
      },
      'report_comparison': {
        'model': new ReportComparisonModel(),
        'service': new BaseService(new ReportComparisonModel())
      },
      'holiday_setting': {
        'model': new HolidaySettingModel(),
        'service': new BaseService(new HolidaySettingModel())
      },
      'users_dpv': {
        'model': new UserDpvModel(),
        'service': new BaseService(new UserDpvModel())
      },
      'area': {
        'model': new AreaModel(),
        'service': new BaseService(new AreaModel())
      },
      'users_tdv': {
        'model': new UserTdvModel(),
        'service': new BaseService(new UserTdvModel())
      },
      'salary_pricelist': {
        'model': new SalaryPricelistModel(),
        'service': new BaseService(new SalaryPricelistModel())
      },
      'salary_pricelist_province': {
        'model': new SalaryPricelistProvinceModel(),
        'service': new BaseService(new SalaryPricelistProvinceModel())
      },
      'organ_pricelist_province': {
        'model': new OrganPricelistProvinceModel(),
        'service': new BaseService(new OrganPricelistProvinceModel())
      },
      'organ_pricelist': {
        'model': new OrganPricelistModel(),
        'service': new BaseService(new OrganPricelistModel())
      },
      'court_account': {
        'model': new CourtAccountModel(),
        'service': new BaseService(new CourtAccountModel())
      },
    },
    getModel(modelName) {
      return this.services[modelName].model
    },
    countData(modelName) {
      return this.services[modelName].service.countDataQuery();
    },
  countDataListDocs(modelName) {
    return this.services[modelName].service.countDataQueryListDocs();
  },
  getList(modelName, params) {
      return this.services[modelName].service.getListQuery(params); 
    },
    updateData(modelName) {
        return this.services[modelName].service.updateDataQuery();
    },
    insertData(modelName) {
      return this.services[modelName].service.insertDataQuery();
    },
    deleteData(modelName) {
      return this.services[modelName].service.deleteDataQuery();
    },
    getByMyId(modelName,params) {
      return this.services[modelName].service.getByMyIdQuery(params);
    },
};
